import type { BadgeTone } from '@/components/base/Badge';
import type { ProjectStatus } from '@/types';

interface StatusConfig {
  label: string;
  tone: BadgeTone;
  icon: string;
  dot: string;
}

export const STATUS_CONFIG: Record<ProjectStatus, StatusConfig> = {
  ACTIVO: {
    label: 'Activo',
    tone: 'primary',
    icon: 'ri-checkbox-circle-line',
    dot: 'bg-primary-500',
  },
  'EN PROCESO': {
    label: 'En proceso',
    tone: 'accent',
    icon: 'ri-time-line',
    dot: 'bg-accent-500',
  },
  DESACTIVADO: {
    label: 'Desactivado',
    tone: 'neutral',
    icon: 'ri-forbid-2-line',
    dot: 'bg-foreground-400',
  },
};

export type StatusFilter = 'TODOS' | ProjectStatus;

export const STATUS_FILTERS: { value: StatusFilter; label: string }[] = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'EN PROCESO', label: 'En proceso' },
  { value: 'ACTIVO', label: 'Activo' },
  { value: 'DESACTIVADO', label: 'Desactivado' },
];